import { createSlice } from '@reduxjs/toolkit';
import API from '../../api';

export const userSlice = createSlice({
    name: 'user',
    initialState: {
        users: [],
        currentUser: null,
    },
    reducers: {
        setUsers: (state, action) => {
            state.users = action.payload;
        },
        setCurrentUser: (state, action) => {
            state.currentUser = action.payload;
        },
    },
});

export const { setUsers, setCurrentUser } = userSlice.actions;

export const fetchUsers = () => async (dispatch) => {
    try {
        const response = await API.get('/api/users');
        dispatch(setUsers(response.data));
    } catch (error) {
        console.error('Error fetching users', error);
    }
};

export default userSlice.reducer;
